<template>
  <div id="TaskEvaluation">
    <h1>【BSC公司指标开发】任务评价</h1>
    <div class="container">
      <div class="eva-item-lists">
        <div class="eva-item eva-item1">
          <el-divider content-position="left">任务信息</el-divider>
          <div class="item">
            <div class="item-info">
              <label>发布:</label>
              <span>张三</span>
            </div>
            <div class="item-info">
              <label>起止时间:</label>
              <span>2022-8-6至2022-8-10</span>
            </div>
          </div>
          <div class="item">
            <div class="item-info">
              <label>执行:</label>
              <span>李四</span>
            </div>
            <div class="item-info">
              <label>任务难度:</label>
              <span>困难</span>
            </div>
          </div>
          <div class="item">
            <div class="item-info">
              <label>奖励:</label>
              <span>1000</span>
            </div>
            <div class="item-info">
              <label>状态</label>
              <span>已完成</span>
            </div>
          </div>
          <div class="item">
            <div class="item-info">
              <label>任务归属:</label>
              <span>数字化管理</span>
            </div>
            <div class="item-info">
              <label>执行进度:</label>
              <el-progress
                class="progress-detail"
                :text-inside="true"
                :stroke-width="14"
                :percentage="100"
              ></el-progress>
            </div>
          </div>
        </div>
        <!-- <div class="eva-item eva-item2">
          <el-divider content-position="left">任务积分奖励</el-divider>
          <div class="item">
            <div class="item-info">
              <label for="">奖励积分</label>
              <el-input-number
                v-model="RewardPoints"
                :min="1"
                :max="10"
                label="描述文字"
                size="mini"
              ></el-input-number>
            </div>
          </div>
        </div> -->
        <div class="eva-item eva-item3">
          <el-divider content-position="left">项目成员能力评价</el-divider>
          <div class="pc-start-wrap">
            <div class="user-lists">
              <ul>
                <li
                  v-for="(item,index) in cepingUserLists"
                  :class="{
                    ac:choUserAc === item.label
                  }"
                  @click="choseUserHandler(item,index)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>
            <div class="items-lists">
              <div class="item">
                <div class="item-info">
                  <label for="">诚信正直</label>
                  <el-slider
                    v-model="startLv.val1"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,0)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
                <div class="item-info">
                  <label for="">思考能力</label>
                  <el-slider
                    v-model="startLv.val2"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,1)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
              </div>
              <div class="item">
                <div class="item-info">
                  <label for="">创新改进</label>
                  <el-slider
                    v-model="startLv.val3"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,2)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
                <div class="item-info">
                  <label for="">企业家精神</label>
                  <el-slider
                    v-model="startLv.val4"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,3)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
              </div>
              <div class="item">
                <div class="item-info">
                  <label for="">执行力</label>
                  <el-slider
                    v-model="startLv.val5"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,4)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
                <div class="item-info">
                  <label for="">规划能力</label>
                  <el-slider
                    v-model="startLv.val6"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,5)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
              </div>
              <div class="item">
                <div class="item-info">
                  <label for="">目标管理</label>
                  <el-slider
                    v-model="startLv.val7"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,6)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
                <div class="item-info">
                  <label for="">培养人才</label>
                  <el-slider
                    v-model="startLv.val8"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,7)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
              </div>
              <div class="item">
                <div class="item-info">
                  <label for="">领导力</label>
                  <el-slider
                    v-model="startLv.val9"
                    :step="1"
                    :min="1"
                    :max="4"
                    show-stops
                    :format-tooltip="(val)=>formatTooltip(val,8)"
                    class="item-slider-point"
                  >
                  </el-slider>
                </div>
                <div class="item-info">
                </div>
              </div>
              <div class="textarear-wrap">
                <label for="">备注</label>
                <el-input type="textarea"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="eva-item eva-item4" v-if="isProjectVisible">
          <el-divider content-position="left">任务满意度</el-divider>
          <div class="item">
            <div class="item-info">
              <label for=""></label>
              <el-radio-group v-model="radioLv">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="采用数字化、无人化的手段完成任务"
                  placement="top-start"
                >
                  <el-radio :label="5">
                    <span>S</span>
                  </el-radio>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="创新型、系统性完成任务"
                  placement="top-start"
                >
                  <el-radio :label="4">
                    <span>A</span>
                  </el-radio>
                </el-tooltip> <el-tooltip
                  class="item"
                  effect="dark"
                  content="超预期完成任务，预判风险且把控风险"
                  placement="top-start"
                >
                  <el-radio :label="3">
                    <span>B</span>
                  </el-radio>
                </el-tooltip> <el-tooltip
                  class="item"
                  effect="dark"
                  content="保质保量完成任务"
                  placement="top-start"
                >
                  <el-radio :label="2">
                    <span>C</span>
                  </el-radio>
                </el-tooltip> <el-tooltip
                  class="item"
                  effect="dark"
                  content="按时完成任务"
                  placement="top-start"
                >
                  <el-radio :label="1">
                    <span>D</span>
                  </el-radio>
                </el-tooltip>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btns">
      <el-button type="primary" size="mini" @click="subCeHandler">提交</el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, getCurrentInstance } from '@vue/composition-api'
export default {
  name: 'TaskEvaluation',
  props: [

  ],
  setup () {
    const vm = getCurrentInstance()
    const route = vm.setupContext.root.$route
    /// /////
    let RewardPoints = ref(0)
    let value2 = ref(0)
    function formatTooltip (val, index) {
      let lvInfo = {
        0: '超差',
        1: '差',
        2: '一般',
        3: '良'
      }
      let tableData = [
        {
          lv: '诚信正直',
          lv1: '不撒谎、不作假',
          lv2: '直言不讳，言出必行，行必果',
          lv3: '公平公正、勤于反思、勇于担责',
          lv4: '一身正气',
          lv5: '能够协同12人团作战'
        },
        {
          lv: '思考能力',
          lv1: '解决问题的能力',
          lv2: '追根溯源，高效解决问题的能力',
          lv3: '寻找问题发生的规律，规避问题发生',
          lv4: '举一反三，从问题发现商机并开枝散叶',
          lv5: '能够公司级项目'
        },
        {
          lv: '创新改进',
          lv1: '思考创新并尝试',
          lv2: '主动创新以提升效率',
          lv3: '产品和业务创新',
          lv4: '利用创新放大产品/服务价值',
          lv5: '能够管理5个公司级项目'
        },
        {
          lv: '企业家精神',
          lv1: '攻坚克难',
          lv2: '主动挑战',
          lv3: '追求卓越',
          lv4: '志在高远',
          lv5: '有产品服务意识'
        },
        {
          lv: '执行力',
          lv1: '快速执行',
          lv2: '高效执行',
          lv3: '超预期执行',
          lv4: '快速纠偏能力',
          lv5: '能够理解公司级复杂项目'
        },
        {
          lv: '规划能力',
          lv1: '产品规划能力',
          lv2: '业务规划能力',
          lv3: '年度战略规划能力',
          lv4: '中长期战略规划能力',
          lv5: '能够理解公司级复杂项目'
        },
        {
          lv: '目标管理',
          lv1: '根据要求设定合理目标',
          lv2: '超越要求制定挑战目标',
          lv3: '根据战略设定组织目标',
          lv4: '制定长期的可持续发展数据目标',
          lv5: '能够理解公司级复杂项目'
        },
        {
          lv: '培养人才',
          lv1: '乐于分享',
          lv2: '经验沉淀',
          lv3: '授权实践',
          lv4: '带动引领',
          lv5: '能够理解公司级复杂项目'
        },
        {
          lv: '领导力',
          lv1: '识别人才、合理分配',
          lv2: '建立机制、高效协同',
          lv3: '激励团队、快乐工作',
          lv4: '建立愿景、超越自我',
          lv5: '能够理解公司级复杂项目'
        }
      ]
      // return lvInfo[val]
      return tableData[index][`lv${val}`]
    }
    let radioLv = ref()
    let isProjectVisible = ref(false)
    let startLv = reactive({
      val1: 0,
      val2: 0,
      val3: 0,
      val4: 0,
      val5: 0,
      val6: 0,
      val7: 0,
      val8: 0,
      val9: 0
    })
    onMounted(() => {
      let isProject = route.query.isProject
      console.log(Boolean(isProject))
      isProjectVisible.value = (+isProject === 1)
    })
    /// ///
    let cepingUserLists = reactive([
      {
        label: '谢凤',
        lvs: [1, 1, 3, 4, 2, 1]
      },
      {
        label: '典斌',
        lvs: [3, 1, 3, 2, 2, 1]
      },
      {
        label: '王跃',
        lvs: [1, 2, 5, 4, 2, 1]
      },
      {
        label: '李四',
        lvs: [1, 2, 1, 4, 2, 1]
      },
      {
        label: '张三',
        lvs: [3, 1, 3, 1, 2, 1]
      }
    ])
    let choUserAc = ref('谢凤')
    let choUserAcIndex = ref(0)
    let choseUserHandler = function (user, index) {
      choUserAc.value = user.label
      choUserAcIndex.value = index
      let [a, b, c, d, e, f] = user.lvs
      startLv.val1 = a
      startLv.val2 = b
      startLv.val3 = c
      startLv.val4 = d
      startLv.val5 = e
      startLv.val6 = f
    }
    onMounted(() => {
      choseUserHandler(cepingUserLists[0], 0)
    })
    /// //提交测评
    function subCeHandler () {
      vm.setupContext.root.$message.success({
        message: '提交成功',
        duration: 1000,
        onClose: function () {
          cepingUserLists.splice(choUserAcIndex.value, 1)
          console.log(cepingUserLists.length)
          if (cepingUserLists.length > 0) {
            choUserAc.value = cepingUserLists[0].label
            choUserAcIndex.value = 0
            choseUserHandler(cepingUserLists[0], choUserAcIndex.value)
          }
        }
      })
    }
    return {
      subCeHandler,
      choUserAcIndex,
      choseUserHandler,
      choUserAc,
      cepingUserLists,
      RewardPoints,
      value2,
      formatTooltip,
      isProjectVisible,
      radioLv,
      startLv
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
h1
  font-size: 26px
  margin-bottom: 30px
  padding-left: 25px
.eva-item-lists
    border-radius: 10px
    margin-bottom 30px
    position relative
    .eva-item
      padding: 2px 10px 10px 10px
      &.eva-item1
        background-color: #F5F7FA
        >>> .el-divider__text
              background-color: #F5F7FA
      &.eva-item1,&.eva-item3
        label
          font-size: 16px
          width 100px
          text-align: justify;
          height 20px
          line-height: 20px
          margin-right: 20px
          text-align right
          font-weight: bolder
        .item+.item
          margin-top: 15px
      &.eva-item4
        >>> label.el-radio
              display: flex
              align-items: center
        >>> .el-radio-group
              display: flex
        .item
          padding-left: 30px
      .item
        display flex
        .item-info
          flex: 1 0
          display flex
          align-items: center
          .progress-detail
            flex: 1 0
            >>> .el-progress-bar__innerText
                  display block
                  vertical-align: none
          span
            font-size: 16px

  .item-slider-point
    width 200px
    margin-right 20px
.el-divider__text
  font-size: 20px
  font-weight: bolder

.btns
  text-align: center
  margin-right: 40px

.pc-start-wrap
  display: flex
  .user-lists
    width 200px
    font-size: 16px
    margin-right: 10px

    .user-lists-title
      font-size: 20px
      text-align: center
      width 100%
      display inline-block
      margin-bottom 10px
    ul
      border 1px solid #ccc
      border-radius: 10px
      padding: 6px
      height 100%
      overflow-y: auto
      margin-left: 41px;
    li
      text-align: center
      line-height: 20px
      cursor pointer
      &:hover
        background-color: #ddd

      &.ac
        color #409eff
  .items-lists
    flex 1
    .item-info
      justify-content: center

.textarear-wrap
  margin-bottom: 20px
  width 90%
  margin: auto
  label
    font-size: 16px
    color: #999
    margin-bottom: 8px
    margin-left 48px
    display: block
</style>
  <!-- &:after{  // 这里 伪元素after 或者 伪元素before 都行
              content: '';
              display: inline-block;
              width: 100%;
            } -->
